module.exports = "/images/seller-welcome-2.png?b50bc0d47ea8e27d82539499269919e2";